module.exports = "<button class=\"btn btn-default\" (click)=\"onBtnClick($event)\" [disabled]=\"isDisabled\">\n  <i name=\"fi-archive\" class=\"sn-icon fi-archive fi\" color=\"text-light\"></i>\n  <span>{{ text }}</span>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/buttons/archive-btn/archive-btn.html
// module id = ./shared/components/common/buttons/archive-btn/archive-btn.html
// module chunks = 0